import React from 'react';

function Privacy() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-gray-100 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Privacy Policy
        </h1>
        
        <div className="space-y-8 text-gray-400">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Information We Collect</h2>
            <p className="leading-relaxed">
              We collect information that you provide directly to us, including your name, email address, 
              and any other information you choose to provide during the interview practice sessions. 
              To provide a personalized interview experience, we request users to upload their resume. 
              All data is stored securely and retained only until your purchase validity period (30 days). After this period, all uploaded resumes and related user data 
              will be permanently deleted from our systems.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Information Sharing</h2>
            <p className="leading-relaxed">
              We do not sell or share your personal information with any third parties. We also don't spam you with calls or messages. Your data is only used for your personal interview.  
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Data Security</h2>
            <p className="leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal 
              information against unauthorized access, alteration, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Payment Information</h2>
            <p className="leading-relaxed">
              We do not store or process any payment-related information. All payment transactions are securely  
              handled by our third-party payment service provider, ensuring compliance with industry-standard  
              security protocols.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Your Rights</h2>
            <p className="leading-relaxed">
              You have the right to access, correct, or delete your personal information. Please use the "Contact Us" page 
              if you wish to exercise any of these rights.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy; 